module.exports = __webpack_public_path__ + "static/media/olx.ca82f2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/olx.png
// module id = 160
// module chunks = 0